import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Form, { FormInput } from '../common/Form';
import { useSelector } from 'react-redux';
import { get } from '../../utils/api';

const typeOptions = {
    ru: [{
        text: 'Основная',
        value: 'main',
    },{
        text: 'Дополнительная',
        value: 'addon',
    },{
        text: 'Специальная',
        value: 'admin',
    }],
    en: [{
        text: 'Main',
        value: 'main',
    },{
        text: 'Additional',
        value: 'addon',
    },{
        text: 'Special',
        value: 'admin',
    }],
};

const CategoryForm = ({ success, error, info, submit,
                        type, nameRu, nameEn, isFolder, folder, priority,
                        setType, setNameRu, setNameEn, setIsFolder, setFolder, setPriority,
                        onSubmit }) => {

    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const event = useSelector(state => state.event);
    const [ foldersOptions, setFoldersOptions ] = useState([]);

	// Запрашиваем информацию о папках категорий
	useEffect(() => {
		const fetchCategories = async (event) => {
			const result = await get('/categories/', { event });
			if(result.error) return;
			let folders = result.data.categories.filter(cat => cat.is_folder);
            let options = [];
            folders.forEach(f => options.push({ text: f.name[lang], value: f._id }));
			setFoldersOptions(options);
		};

		setFoldersOptions([]);
		if(event?._id) fetchCategories(event._id);
	}, [ event, lang ]);
    
    return (
        <Form
            success={success}
            error={error}
            info={info}
            submit={t(submit)}
            onSubmit={onSubmit}
        >
            <FormInput
                id='nameRu'
                type='text'
                value={nameRu}
                onChange={setNameRu}
                label={t('category.name_ru')}
                className='lang-ru'
                required={true}
            />
            <FormInput
                id='nameEn'
                type='text'
                value={nameEn}
                onChange={setNameEn}
                label={t('category.name_en')}
                className='lang-en'
                required={true}
            />
            <FormInput
                id='priority'
                type='text'
                value={priority}
                onChange={setPriority}
                label={t('category.priority')}
            />
            <FormInput
                id='folder'
                type='select'
                value={type === 'main' ? folder ?? '' : ''}
                label={t('category.folder')}
                hint={t('category.folder_hint')}
                list={foldersOptions}
                disabled={isFolder || type !== 'main'}
                onChange={setFolder}
            />
            <fieldset>
                <legend>{t('category.is_folder')}</legend>
                <FormInput
                    id='isFolder'
                    type='checkbox'
                    value={isFolder ? 'true' : ''}
                    label={t('category.is_folder_label')}
                    disabled={!setIsFolder}
                    onChange={value => {
                        if(setIsFolder) {
                            setIsFolder(value ? false : true);
                        }
                        if(!value) {
                            if(setType) {
                                setType('main');
                            }
                            setFolder('');
                        }
                    }}
                />
            </fieldset>
            <FormInput
                id='type'
                type='radio'
                value={type}
                disabled={isFolder || !setType}
                label={t('category.type')}
                list={typeOptions[lang]}
                required={true}
                onChange={value => { if(setType) setType(value); }}
            />
        </Form>
    );
};

CategoryForm.propTypes = {
    success:  PropTypes.string.isRequired,
    error:  PropTypes.string.isRequired,
    info:  PropTypes.string.isRequired,
    submit:  PropTypes.string.isRequired,
    type:  PropTypes.oneOf(['main','addon','admin']).isRequired,
    nameRu:  PropTypes.string.isRequired,
    nameEn:  PropTypes.string.isRequired,
    priority:  PropTypes.string.isRequired,
    isFolder: PropTypes.bool,
    folder: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    setType: PropTypes.func,
    setNameRu: PropTypes.func.isRequired,
    setNameEn: PropTypes.func.isRequired,
    setIsFolder: PropTypes.func,
    setFolder: PropTypes.func.isRequired,
    setPriority: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default CategoryForm;
